<template>
  <section class="section-base section-color">
    <div class="container">
      <div class="title" data-anima="fade-bottom" data-time="1000">
        <h2>A prioridade é você</h2>
        <p>NOSSOS SERVIÇOS</p>
      </div>
      <hr class="space-xs"/>
      <div class="tab-box tab-top-right" data-tab-anima="fade-bottom" data-anima="fade-bottom"
           data-time="1000">
        <div class="panel active">
          <div class="grid-list" data-columns="4" data-columns-lg="2" data-columns-sm="1">
            <div class="grid-box">
              <div class="grid-item">
                <div class="cnt-box cnt-box-top-icon boxed">
                  <i class="im-monitor-phone"></i>
                  <div class="caption">
                    <h2>Cotações<br> Online</h2>
                    <p>
                      Nossa plataforma está em constante atualização. Buscamos criar um portal onde,
                      com facilidade, você encontrará tudo o que precisa.<br><br><br><br><br>
                    </p>
                  </div>
                </div>
              </div>
              <div class="grid-item">
                <div class="cnt-box cnt-box-top-icon boxed">
                  <i class="im-handshake"></i>
                  <div class="caption">
                    <h2>Parcerias<br>Duradouras</h2>
                    <p>
                      Mais do que clientes, parceiros. Temos como princípio ajudar e fortalecer os
                      parceiros SKY SOLAR. Acreditamos em relacionamentos de longo prazo que agregam
                      valor a ambas partes. <br><br><br>
                    </p>
                  </div>
                </div>
              </div>
              <div class="grid-item">
                <div class="cnt-box cnt-box-top-icon boxed">
                  <i class=" im-notepad"></i>
                  <div class="caption">
                    <h2>Sistema de Venda Direta</h2>
                    <p>
                      Sendo uma revenda autorizada Sky Solar você pode faturar os produtos
                      diretamente para o consumidor final e facilitar as suas
                      vendas.<br><br><br><br><br>
                    </p>
                  </div>
                </div>
              </div>
              <div class="grid-item">
                <div class="cnt-box cnt-box-top-icon boxed">
                  <i class="im-business-man"></i>
                  <div class="caption">
                    <h2>Atendimento Personalizado</h2>
                    <p>
                      Nossos vendedores estão prontos para atendê-lo e tirar suas dúvidas com
                      eficácia e agilidade. Com um dos maiores estoques do Brasil e uma logística
                      eficiente, entregamos a segurança que você precisa para fechar seus negócios.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NossosServicos',
};
</script>

<style scoped>

</style>
